import { emailStatus, EMAIL_KIND, fmtDate } from "@/lib/api";

export const EmailBadge = ({ log, testId }) => {
  const [label, cls] = emailStatus(log);
  return (
    <span data-testid={testId} title={log.error || log.last_event || ""} className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${cls}`}>
      {label}
    </span>
  );
};

export const EmailLogList = ({ logs, testId }) => (
  <ul data-testid={testId} className="mt-2 flex flex-col gap-1.5 text-xs">
    {logs.length === 0 && <li className="text-slate-500">Aucun e-mail envoyé.</li>}
    {logs.map((l, i) => (
      <li key={i} data-testid={`${testId}-item-${i}`} className="flex flex-wrap items-center gap-2 text-slate-700">
        <EmailBadge log={l} testId={`${testId}-badge-${i}`} />
        <span className="font-medium">{EMAIL_KIND[l.kind] || l.kind}</span>
        <span className="text-slate-500">→ {l.to}</span>
        <span className="text-slate-400">{fmtDate(l.at)}</span>
        {l.ok === false && <span className="text-red-700 break-all">{l.error}</span>}
      </li>
    ))}
  </ul>
);
